// extracted by mini-css-extract-plugin
module.exports = {"linkDetailsContainer":"styles_linkDetailsContainer__AEtr6","descriptionContainer":"styles_descriptionContainer__tHQcq"};